import { Title } from "@vds3/typography";
import React from "react";
import { MarginSpacerM, MarginSpacerL} from "../../../Checkout/styleTag";
import DueMonthlyPrint from "./Component/DueMonthlyPrint";



const OrderSummaryPrint = (props)=>{
    return(
        <div >
            <div style={{ marginLeft: "-30px" }}>
				<img height="50" width="189" className='ImageContent' src="images/v-logo.svg" />
			</div>
        <MarginSpacerL/>
        <Title size="medium" bold>Order summary </Title>
        <MarginSpacerM/>
        <DueMonthlyPrint {...props}/>
        </div>
    )
}

export default OrderSummaryPrint